import Navbar from "components/navbar/Navbar";
import Layout from "components/structure/Layout";
import React, { useEffect, useRef, useState } from "react";
import { PieChart, } from '@mui/x-charts/PieChart';
import { Box, Button, Card, CardActions, CardContent, Grid, MenuItem, Modal, Select, Stack, Typography } from "@mui/material";
import { BarChart } from '@mui/x-charts/BarChart';
import { useMsal } from '@azure/msal-react';
import axios from 'axios'
import ReportService from "services/ReportService";
const Report = () => {
  const [height, setHeight] = useState('800px');

  // const onLoad = () => {
  //   setHeight(ref.current.contentWindow.document.body.scrollHeight + 'px');
  // };
  // useEffect(() => {
  //   onLoad();
  // }, []);

  const [data, setData] = useState([])

  const [selectedReport, setSelectedReport] = useState('');
  const [openModal, setOpenModal] = useState(false);

  const handleReportSelect = (event) => {
    setSelectedReport(event.target.value);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedReport('');
  };

  const selectedReportData = data.find(report => report.reportId === selectedReport);


  // const fetchModules = async () => {
  //   try {
  //     const response = await Service.getCroplist();
  //     const activeCropList = response?.data?.response?.filter(crop => crop.isActive);
  //     console.log("🚀 ~ fetchModules ~ activeCropList:", activeCropList)
  //     setCropList(activeCropList);

  //   } catch (error) {
  //     setOpenAlert(true);
  //     setSeverity("error");
  //     setMessage(error?.response?.data?.message || error?.message);
  //   }
  // }

  const pieParams = { height: 200, margin: { right: 5 } };
  const palette = ['red', 'blue', 'green'];
  // const { instance, inProgress, accounts, logger } = useMsal();

  // const initializeSignIn = () => {
  //   instance.loginRedirect();

  // };

  // const test = (async () => {
  //   const request = {
  //     scopes: [],
  //     account: accounts[0],

  //   };
  //   const authResult = await instance.acquireTokenSilent(request)
  //   console.log('authResult', authResult)
  // })

  // if (accounts && accounts.length > 0) {
  //   test()
  // }

 

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await ReportService.getReport("Report");
        const activeCropList = response?.data?.response
        setData(activeCropList);
      } catch (error) {
        // setOpenAlert(true);
        // setSeverity("error");
        // setMessage(error?.response?.data?.message || error?.message);
      }
    }
    fetchModules()
  }, [])

  return (
    <Layout title={'Agri360 ESG Portal'} style={{ marginBottom: "100px", marginTop: "64px" }}>
      <div>
        <Select
          value={selectedReport}
          onChange={handleReportSelect}
          displayEmpty
          sx={{ minWidth: 200, mb: 2 }}
        >
          <MenuItem value="" disabled>Select a Report</MenuItem>
          {data.map(report => (
            <MenuItem key={report.reportId} value={report.reportId}>
              {report.reportName}
            </MenuItem>
          ))}
        </Select>
        {selectedReport && (
          <Box sx={{
            border: '1px solid #ccc',
            borderRadius: 1,
            padding: 2,
            marginTop: 2,
            backgroundColor: '#f9f9f9',
          }}>
            <Typography variant="h6" component="h2" gutterBottom>
              {selectedReportData?.reportName}
            </Typography>
            <iframe title="Farmer"
              width="100%"
              height={height}
              scrolling='no'
              frameBorder='0'
              src={`https://app.powerbi.com/reportEmbed?reportId=${selectedReportData.reportType}&autoAuth=true`}
              frameborder="0"
              allowFullScreen="true">
            </iframe>
          </Box>
        )}
      </div>
    </Layout>
  );
};



export default Report;
